import React, { useState } from 'react';
import { useEffect } from 'react';
import useAuth from '../hooks/useAuth';
import useRefresh from '../hooks/useRefresh';
import Navloader from '../components/Reusables/NavLoader/Navloader';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { singleFlightRefresh } from './refreshManager';

function Persistlogin({ children }: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefresh();
  const { auth, setAuth } = useAuth();

  useEffect(() => {
    let isMounted = true;
    const verifyOrHydrate = async () => {
      try {
        // If we already have an in-memory access token, don't block.
        if (auth?.accessToken) return;

        // Try to hydrate from storage first (fast, no network).
        const [storedAccess, storedRefresh] = await Promise.all([
          AsyncStorage.getItem('accessToken'),
          AsyncStorage.getItem('refreshToken'),
        ]);

        if (storedAccess) {
          setAuth({
            accessToken: storedAccess,
            refreshToken: storedRefresh || '',
          });
          return;
        }

        // No stored access token: fall back to refresh if possible.
        // Route through singleFlightRefresh so this never races with a
        // concurrent interceptor/SSE refresh (backend rotates the refresh
        // token on success → two concurrent POSTs with the same token would
        // 403 the second one and force a logout cascade).
        await singleFlightRefresh('pos', refresh);
      } catch (error) {
        console.log(error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (auth?.accessToken) {
      setIsLoading(false);
    } else {
      verifyOrHydrate().then(() => {});
    }

    // Return a cleanup function that sets isMounted to false
    return () => {
      isMounted = false;
    };
  }, [auth?.accessToken, refresh, setAuth]);

  return <>{isLoading ? <Navloader /> : children}</>;
}

export default Persistlogin;
